(function(Drupal, Backbone, _, $) {

  // Use strict mode.
  'use strict';

  /**
   * Gallery handler.
   */
  var GalleryView = Backbone.View.extend({

    // MUST BE PASSED IN el: ".paragraph--type--images-gallery",
    events: {
      'click .field__item': '_next',
      'click .hero-gallery-bullet': '_clickBullet',
      'click .next': '_next',
      'click .prev': '_prev'
    },
    model: null,
    _interval: 0,

    initialize: function(options) {
      this.options = options;
      this.model = new Backbone.Model({index:0});
      var bullets = '<ul class="hero-gallery-bullets">';
      this.$('.field__item').each(function() {
        var s = $(this).find('img').attr('src');
        bullets += '<li class="hero-gallery-bullet"><a href="'+s+'">◼︎</a></li>';
        $(this).css('background-image','url('+s+')').find('img').remove();
      }).not(':first-child').hide();
      bullets += '</ul>';

      var $bullets = $(bullets);
      $bullets.find('a').first().addClass('active');

      this.$el.addClass('hero-gallery');
      if (this.$('.field__item')[1]) {
        this.$el.append('<nav class="hero-gallery-nav"><span class="prev"><</span><span class="next">></span></nav>').append($bullets);
        this.model.set({length:this.$('.field__item').length-1});
        this.listenTo(this.model, 'change', this.render);
      }
      if (this.$el.hasClass('autoplay')) {
        this._autoCycle();
      }
      _.bindAll(this, '_next', '_prev', 'render', '_clickBullet', '_autoCycle', '_autoNext');
    },

    _autoCycle: function() {
      var view = this;
      var f = function() {
        view._autoNext();
      }
      view.$el.on('click', function() {
        clearInterval(view._interval);
      });
      view._interval = setInterval(f, 5000);
    },

    render: function() {
      console.log('3');
      var i = this.model.get('index');
      var dir = this.model.get('direction');

      // change image
      var $lastImg = this.$('.field__item:visible');
      var $newImg = this.$('.field__item:eq('+i+')').stop(true, true).fadeTo(0,0);

      // active class
      this.$('.hero-gallery-bullet a.active').removeClass('active');
      this.$('.hero-gallery-bullet:eq('+i+') a').addClass('active');

      //direction?
      var dest = '';
      if (dir == 'next') {
        $newImg.css('left','100%');
        dest = '-100%';
      } else if (dir == 'prev') {
        $newImg.css('left','-100%');
        dest = '100%';
      } else {
        $lastImg.stop(true, true).animate({opacity:0}, 350, function() {
          $newImg.css('left','').animate({opacity:1}, 450);
        });
        return;
      }

      $lastImg.stop().animate({opacity:0, left:dest}, 300, function() {
        $(this).css('left','');
      });
      $newImg.stop().animate({opacity:1, left:0}, 300, function() {
        $(this).css('left','');
      });
    },

    _clickBullet: function(e) {
      e.preventDefault();
      var $b = $(e.currentTarget);
      if ($b.hasClass('active')) {
        return;
      }
      var i = $b.index();
      var ci = this.model.get('index');

      var dir = (i>ci) ? 'next' : 'prev';

      this.model.set({index:i, direction:dir});

    },

    _autoNext:function(e) {
      var l = this.model.get('length');
      var i = this.model.get('index');
      var n = i+1;
      if (n>l) {
        n = 0;
      }
      this.model.set({index:n, direction:null});
    },

    _next: function(e) {
      var l = this.model.get('length');
      var i = this.model.get('index');
      var n = i+1;
      if (n>l) {
        n = 0;
      }
      this.model.set({index:n, direction:'next'});
    },

    _prev: function(e) {
      var l = this.model.get('length');
      var i = this.model.get('index');
      var n = i-1;
      if (n<0) {
        n = l;
      }
      this.model.set({index:n, direction:'prev'});
    }
  });

  Drupal.behaviors.inline_gallery = {
    attach: function (context, settings) {
      $('.paragraph--type--gallery, .inline-gallery').each(function() {
        if (!$(this).hasClass('gallery-processed')) {
          $(this).addClass('gallery-processed');
          var pv = new GalleryView({ el: $(this) });
        }
      });
    },
  };

})(Drupal, Backbone, _, jQuery);
